/* eslint-disable no-unused-vars */
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useEffect, useState } from 'react';
import {
  addHandler,
  removeHandler,
  selectTopKeyHandler,
} from 'store/transitionSlice';
import { v4 as uuid } from 'uuid';

// Мысль в том, чтобы разделить обработчики по группам с уникальным id
// id групп находятся в упорядоченном массиве, активной является группа
// обработчиков, id которой является последним элементом массива (аналогия с z-index)
// В родительском элементе нужно вызвать useUniqueKeyHandler чтобы зарегистрировать группу.
// Далее полученный id можно использовать во всех потомках, для отнесения обработчика к этой группе.
// При размонтировании родительского компонента, группа будет уничтожена
// Когда применять: В компонентах, которые могут отрисоваться на странице в множественном количестве в разных деревьях (поиск на странице и в модалке)

export const useDocumentHandler = ([type, handler, options]: Parameters<
  typeof document.addEventListener
>) => {
  useEffect(() => {
    document.addEventListener(type, handler, options);

    return () => {
      document.removeEventListener(type, handler, options);
    };
  }, [handler]);
};

export const useUniqueKeyHandler = () => {
  const dispatch = useAppDispatch();
  const [id] = useState(uuid());

  useEffect(() => {
    dispatch(addHandler(id));

    return () => {
      dispatch(removeHandler(id));
    };
  }, []);

  return id;
};

export const useRegisterKeyHandler = ({
  handler,
  id,
}: {
  handler: (e: KeyboardEvent) => void;
  id: string;
}) => {
  const istopHandler = useAppSelector(selectTopKeyHandler) === id;

  useEffect(() => {
    const wrap = (e: KeyboardEvent) => {
      istopHandler && handler(e);
    };

    document.addEventListener('keydown', wrap, true);

    return () => {
      document.removeEventListener('keydown', wrap, true);
    };
  }, [handler, istopHandler]);
};
